"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = Component;
const Contexts = __importStar(require("@genesys/client-core/lib/contexts"));
const Importer = __importStar(require("@genesys/client-core/lib/data-upload"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Exporter = __importStar(require("@genesys/client-core/lib/exporter"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const update_system_status_1 = require("@genesys/client-core/lib/update-system-status");
const GraphQlRequest = __importStar(require("@genesys/graphql-request"));
const DateHelper = __importStar(require("@genesys/shared/lib/date-helper"));
const SystemStatusEnum = __importStar(require("@genesys/shared/lib/enums/system-status"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const moment_1 = __importDefault(require("moment"));
const React = __importStar(require("react"));
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const uuid_1 = require("uuid");
const SharedElements = __importStar(require("../nevada-shared/elements"));
const SharedTools = __importStar(require("../nevada-shared/functions"));
const NevadaTable = __importStar(require("../nevada-shared/nevada-table"));
const SharedTypes = __importStar(require("../nevada-shared/types"));
const Actions = __importStar(require("./actions"));
const queries_1 = require("./queries");
const productQuery = (0, graphql_tag_1.default) `
  query NevadaProduct {
    product {
      genesysNumberPrefixes {
        id
        genesysNo
      }
    }
  }
`;
function Component(props) {
    const updateTestSystem = (system) => props.dispatch(Actions.setTestSystem(system));
    const toggleNode = (testId, path) => props.dispatch(Actions.toggleNodeChildren(testId, path));
    const genesysNoOnly = props.inputRows.map((x) => x.genesysNo.split("-")[0]);
    const duplicates = new Set(genesysNoOnly.filter((e, i, a) => a.indexOf(e) !== i));
    const hasDupes = duplicates.size > 0;
    const systems = props.systemsToTest;
    const { authorization, graphqlEndpoint } = React.useContext(Contexts.clientConfigContext);
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: productQuery, variables: {} }, (product) => {
        const regEx = new RegExp("^" +
            product.product.genesysNumberPrefixes.genesysNo +
            "?([\\d]){6}-\\d+", "gi");
        const showResults = () => props.dispatch(Actions.showResult(true, props.inputRows
            .filter((r) => r.genesysNo.match(regEx))
            .map((r) => createSystemInfo(r.genesysNo))));
        return (React.createElement(Contexts.UserProfileContext.Consumer, null, (userProfile) => {
            const dateFormatter = (date) => DateHelper.getDateString(date, userProfile.locale);
            return (React.createElement(Elements.StandardContainer, null,
                hasDupes && (React.createElement(SharedElements.StyledDiv, null,
                    React.createElement("img", { src: `/assets/images/component-messages/warning.png` }),
                    React.createElement("span", null,
                        Array.from(duplicates).join(","),
                        " appears more than once. Pls remove duplicates"))),
                React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
                    React.createElement(Elements.FlexContainerRow, { center: false },
                        React.createElement(Elements.FlexContainerStack, { center: false, centerVertically: false },
                            props.inputRows.map((r, ix) => (React.createElement(SharedElements.InputRowContainer, { key: r.id },
                                React.createElement(Elements.InputEditText, { value: r.genesysNo, onChange: (e) => props.dispatch(Actions.setGenesysNo(e.target.value, ix)), placeholder: "Genesys number" }),
                                React.createElement(Elements.DeleteButton, { onClick: () => props.dispatch(Actions.deleteTest(ix)), disabled: props.inputRows.length <= 1 || props.running })))),
                            React.createElement(Elements.FlexContainerRow, { center: false },
                                React.createElement(Elements.AddButton, { onClick: () => props.dispatch(Actions.addTest()), disabled: props.running }))),
                        React.createElement(SharedElements.DataControlContainer, null,
                            React.createElement(Elements.FlexContainerRow, { style: {
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                } },
                                React.createElement("span", null, "Size: "),
                                React.createElement(Elements.InputEditText, { value: props.runningSize, disabled: props.running, style: {
                                        width: "40px"
                                    }, width: "40px", type: "number", min: "0", onChange: (e) => props.dispatch(Actions.setRunningSize(parseInt(e.target.value, 10))), placeholder: "Running size" })),
                            React.createElement(Exporter.XlsxSingleSheetExport, { data: props.inputRows.map((g) => [g.genesysNo]), filename: "Nevada test " + dateFormatter((0, moment_1.default)()) }, (download) => (React.createElement(Elements.StandardButton, { onClick: download, disabled: props.running }, "Export"))),
                            React.createElement(Importer.SimpleDataUploadContainer, { onParsed: (data) => data.length > 0 &&
                                    props.dispatch(Actions.replaceGenesysNo(data.map((d) => d[0]))) }, (upload) => (React.createElement(Elements.StandardButton, { onClick: upload, disabled: props.running }, "Import"))),
                            React.createElement(Elements.StandardButton, { onClick: showResults, disabled: props.running || props.runningSize <= 0 || hasDupes }, "Run tests")),
                        props.showResults && (React.createElement(Contexts.ScreenAmountProfileContext.Consumer, null, (screenAmount) => (React.createElement(NevadaTable.TableContainer, null, systems.map((x) => {
                            return (React.createElement(NevadaTable.TableRow, { key: x.internalId, referenceSystemName: x.name, referenceSystemNo: x.fileNo, referenceSystemRev: x.refRevisionNo, result: x.result, rowType: "nevada", status: x.status, internalId: x.internalId, systemIsExpanded: x.expanded, systemRowIsOk: x.ok, systemType: x.systemType, testSystemNo: x.fileNo, testSystemRev: x.newRevisionNo || 0, toggleNode: toggleNode, toggleSystem: () => {
                                    updateTestSystem(Object.assign(Object.assign({}, x), { expanded: !x.expanded }));
                                }, runRequest: () => {
                                    runRequests(x, updateTestSystem, screenAmount.getAmountFormat, dateFormatter, graphqlEndpoint, authorization);
                                } }));
                        }))))),
                        props.showResults && (React.createElement(Elements.FlexContainerStack, { center: false, justifyContent: "start" },
                            React.createElement(Exporter.XlsxSingleSheetExport, { filename: "Nevada" + dateFormatter((0, moment_1.default)()), data: props.systemsToTest.some((s) => s.status < SharedTypes.Status.Complete)
                                    ? []
                                    : exportTestSystems(props.systemsToTest.map((s) => s)) }, (onClick) => (React.createElement(Elements.StandardButton, { onClick: onClick, disabled: props.systemsToTest.some((s) => s.status < SharedTypes.Status.Complete) }, "Export differences")))))))));
        }));
    }));
}
function createSystemInfo(text) {
    const regEx = new RegExp(/^[DSG]/, "i");
    const split = text.trim().replace(regEx, "").split("-");
    const fileNo = Number.parseInt(split[0], 10);
    const revisionNo = Number.parseInt(split[1], 10);
    return {
        fileNo: fileNo,
        refRevisionNo: revisionNo,
        newRevisionNo: undefined,
        refRevisionId: undefined,
        newRevisionId: undefined,
        name: undefined,
        systemType: undefined,
        status: SharedTypes.Status.Idle,
        internalId: (0, uuid_1.v4)(),
        result: undefined,
        expanded: false,
        ok: false
    };
}
function excelColumns() {
    return [
        { columnName: "name", displayName: "Name" },
        { columnName: "tags", displayName: "" },
        { columnName: "unit", displayName: "Unit" },
        { columnName: "ref", displayName: "Reference" },
        { columnName: "test", displayName: "Test" }
    ];
}
function getSystemHeaderValues(col, s) {
    switch (col) {
        case "name": {
            return s.name;
        }
        case "unit": {
            return "";
        }
        case "tags": {
            return s.ok
                ? "OK"
                : s.result.type === "error"
                    ? s.result.errorText
                    : "";
        }
        case "test": {
            return s.newRevisionNo ? s.fileNo + "-" + s.newRevisionNo : "";
        }
        case "ref": {
            return s.fileNo + "-" + s.refRevisionNo;
        }
        case "diff": {
            return "";
        }
        default:
            return (0, ts_exhaustive_check_1.exhaustiveCheck)(col);
    }
}
function exportTestSystems(systems) {
    const columns = excelColumns();
    return systems
        .map((s) => {
        const header = columns.map((x) => getSystemHeaderValues(x.columnName, s));
        const result = s.result;
        if (result.type === "error") {
            return [header];
        }
        else {
            return [
                ...[...[header]],
                ...SharedTools.compareResult(result, columns, `${s.fileNo}; ref: ${s.refRevisionNo}; test: ${s.newRevisionNo}`)
            ];
        }
    })
        .reduce((a, b) => [...a, ...b], [columns.map((x) => x.displayName)]);
}
async function runRequests(system, update, getFormat, dateFormatter, graphqlEndpoint, authorization) {
    let updatedSystem = Object.assign(Object.assign({}, system), { status: SharedTypes.Status.Creating });
    update(updatedSystem);
    try {
        const systemFileResult = await SharedTools.getSystemInfo(updatedSystem.fileNo, graphqlEndpoint, authorization);
        const info = mapSystemFileResultToNevadaSystem(systemFileResult, updatedSystem);
        updatedSystem = info.system;
        update(updatedSystem);
        const create = await createSystem(updatedSystem, info.fileId, dateFormatter, graphqlEndpoint, authorization);
        if (create.result && create.result.type === "error") {
            updatedSystem = Object.assign(Object.assign({}, create), { status: SharedTypes.Status.Complete });
            update(updatedSystem);
            return;
        }
        updatedSystem = Object.assign(Object.assign({}, create), { status: SharedTypes.Status.Calculating });
        update(updatedSystem);
        const calculate = await calculateSystem(updatedSystem, graphqlEndpoint, authorization);
        updatedSystem = Object.assign(Object.assign({}, calculate), { status: SharedTypes.Status.Comparing });
        update(updatedSystem);
        const compareResponse = await compareSystems(updatedSystem.fileNo, updatedSystem.refRevisionNo, updatedSystem.newRevisionNo, graphqlEndpoint, authorization);
        const compare = buildSystemBasedOnResponse(compareResponse, updatedSystem, getFormat);
        updatedSystem = Object.assign(Object.assign({}, compare), { status: SharedTypes.Status.Complete });
        // biome-ignore lint: -
    }
    catch (e) {
        updatedSystem = Object.assign(Object.assign({}, updatedSystem), { status: SharedTypes.Status.Complete, result: {
                type: "error",
                errorText: "Error while " + SharedTypes.Status[updatedSystem.status]
            } });
    }
    update(updatedSystem);
}
function buildSystemBasedOnResponse(compareResponse, system, getFormat) {
    if (compareResponse.user.nevadaCompareSystemRevisions.hasError) {
        return Object.assign(Object.assign({}, system), { result: {
                type: "error",
                errorText: compareResponse.user.nevadaCompareSystemRevisions.errorText
            }, ok: false });
    }
    const nevadaCompareSystemRevisions = compareResponse.user.nevadaCompareSystemRevisions;
    const resultNodes = SharedTools.buildResultNodes(nevadaCompareSystemRevisions.compareResult, getFormat);
    const ok = resultNodes.every((r) => r.ok);
    return Object.assign(Object.assign({}, system), { result: {
            type: "result",
            nodes: resultNodes,
            warnings: nevadaCompareSystemRevisions.warnings || []
        }, ok: ok });
}
function mapSystemFileResultToNevadaSystem(systemFileIdResult, system) {
    return {
        system: Object.assign(Object.assign({}, system), { systemType: systemFileIdResult.user.genesysNumberToFile.systemTypeId, name: systemFileIdResult.user.genesysNumberToFile.name, refRevisionId: systemFileIdResult.user.genesysNumberToFile.systems.find((s) => s.revisionNo === system.refRevisionNo).id }),
        fileId: systemFileIdResult.user.genesysNumberToFile.id
    };
}
async function calculateSystem(system, graphqlEndpoint, authorization) {
    const calculationResult = await (0, update_system_status_1.updateSystemStatus)(() => ({}), false, system.newRevisionId, SystemStatusEnum.SystemStatus.LockSuccess, graphqlEndpoint, authorization);
    switch (calculationResult.type) {
        case "UpdateSystemResultSuccess":
            return Object.assign({}, system);
        case "UpdateSystemResultReject":
        default:
            throw new Error();
    }
}
async function createSystem(system, systemFileId, dateFormatter, graphqlEndpoint, authorization) {
    const updatedSystemFileResult = await GraphQlRequest.request(queries_1.nevadaCreateRevision, {
        comment: "Nevada " + dateFormatter((0, moment_1.default)()),
        systemFileId: systemFileId,
        revisionNo: system.refRevisionNo
    }, false, graphqlEndpoint, authorization);
    if (updatedSystemFileResult.nevadaCreateNewSystemRevision.hasError) {
        return Object.assign(Object.assign({}, system), { result: {
                type: "error",
                errorText: updatedSystemFileResult.nevadaCreateNewSystemRevision.errorMessage
            }, ok: false });
    }
    const testSystem = updatedSystemFileResult.nevadaCreateNewSystemRevision.systemFile.systems.reduce((a, b) => (!a || b.revisionNo > a.revisionNo ? b : a), undefined);
    return Object.assign(Object.assign({}, system), { newRevisionNo: testSystem.revisionNo, newRevisionId: testSystem.id });
}
async function compareSystems(fileNo, refRevisionNo, newRevisionNo, graphqlEndpoint, authorization) {
    const compareResponse = await GraphQlRequest.request(queries_1.nevadaCompareSystems, {
        input: {
            genesysNo: fileNo,
            revisionKey: refRevisionNo,
            revisionTest: newRevisionNo
        }
    }, false, graphqlEndpoint, authorization);
    return compareResponse;
}
//# sourceMappingURL=container-component.js.map